import React from 'react';
import { Box, ThemeProvider, createTheme } from '@mui/material';
import SectionHeaderTestPage from './SectionHeaderTestPage';

// Create a light theme for the test layout
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#4A2EDF'
    },
    secondary: {
      main: '#32E170'
    },
    background: {
      default: '#FFFFFF',
      paper: '#F9FAFB'
    },
    text: {
      primary: '#101828',
      secondary: '#667085'
    }
  }
});

/**
 * Test layout component for displaying test pages
 */
const TestLayout = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: 'background.default',
          color: 'text.primary',
        }}
      >
        <SectionHeaderTestPage />
      </Box>
    </ThemeProvider>
  );
};

export default TestLayout;
